import {IFieldMeta} from 'entities/metadata';
import {EFormFieldWatcherActions, EFormFieldWatcherConditions, EFormFieldWatcherConnective} from 'shared/constants/watchers';

export const getMonitorProgramCustomWatchers = (fieldMeta: IFieldMeta) => {
    if (fieldMeta.key === 'P_DOC_IDS') {
        return [{
            conditions: [{
                when: EFormFieldWatcherConditions.unset,
                target: 'P_DATE_FROM',
            },
            {
                when: EFormFieldWatcherConditions.unset,
                target: 'P_DATE_TO',
                withConnective: EFormFieldWatcherConnective.AND,
            }],
            perform: [EFormFieldWatcherActions.require],
        },
        {
            conditions: [{when: EFormFieldWatcherConditions.set, target: 'P_DOC_IDS'}],
            perform: [EFormFieldWatcherActions.addValidationRules],
            withValidationRules: [{
                mask: 'documentIdentifiers',
            }],
        },
        {
            conditions: [{
                when: EFormFieldWatcherConditions.set,
                target: 'P_DOC_IDS',
                name: 'A',
            },
            {
                when: EFormFieldWatcherConditions.set,
                target: 'P_DATE_FROM',
                name: 'B',
            },
            {
                when: EFormFieldWatcherConditions.set,
                target: 'P_DATE_TO',
                name: 'C',
            }],
            conditionsExpression: 'A && (B || C)',
            perform: [EFormFieldWatcherActions.addFieldError],
            withErrorToSet: 'Поля "Дата с" и "Дата по" должны быть пустыми',
        },
        ];
    }
    if (fieldMeta.key === 'P_DATE_FROM') {
        return [
            {
                conditions: [{
                    when: EFormFieldWatcherConditions.unset,
                    target: 'P_DOC_IDS',
                }],
                perform: [EFormFieldWatcherActions.require],
            },
            {
                conditions: [
                    {
                        when: EFormFieldWatcherConditions.set,
                        target: 'P_DATE_FROM',
                    },
                    {
                        when: EFormFieldWatcherConditions.set,
                        target: 'P_DOC_IDS',
                        withConnective: EFormFieldWatcherConnective.AND,
                    }],
                perform: [EFormFieldWatcherActions.addFieldError],
                withErrorToSet: 'Поле "Идентификаторы документов" должно быть пустым',
            },
        ];
    }
    if (fieldMeta.key === 'P_DATE_TO') {
        return [{
            conditions: [{
                when: EFormFieldWatcherConditions.unset,
                target: 'P_DOC_IDS',
            }],
            perform: [EFormFieldWatcherActions.require],
        },
        {
            conditions: [
                {
                    when: EFormFieldWatcherConditions.set,
                    target: 'P_DATE_TO',
                },
                {
                    when: EFormFieldWatcherConditions.set,
                    target: 'P_DOC_IDS',
                    withConnective: EFormFieldWatcherConnective.AND,
                }],
            perform: [EFormFieldWatcherActions.addFieldError],
            withErrorToSet: 'Поле "Идентификаторы документов" должно быть пустым',
        },
        ];
    }

    return undefined;
};
